import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideUserOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="ユーザー管理"
      description="ユーザーアカウントの登録・編集・削除・権限設定を行う管理機能です。ADMIN権限のユーザーのみ操作可能です。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="user/register">新規ユーザーを登録して権限を付与する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              新しいユーザーアカウントを作成し、適切な権限を設定します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="user/update">ユーザー情報を変更する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              既存ユーザーのメールアドレス・ユーザー名・パスワードを変更します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="user/delete">ユーザーを削除する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              不要になったユーザーアカウントを削除します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="user/role">ユーザーの権限を変更する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              ユーザーに割り当てられたロール・権限を変更します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="user/search">ユーザーを検索する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              条件を指定してユーザーを検索・絞り込みます。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideUserOverview;
